import React from 'react';
import { X, Phone, Mail, MessageSquare, ExternalLink } from 'lucide-react';
import { useTranslation } from 'react-i18next';

export const ContactGuestModal = ({
  isOpen,
  onClose,
  reqClientName,
  phone,
  email,
  orgNameInvoice
}) => {
  const { t } = useTranslation();

  if (!isOpen) return null;

  const handlePhoneCall = () => {
    window.open(`tel:${phone}`, '_self');
  };

  const handleEmail = () => {
    if (email) {
      window.open(`mailto:${email}`, '_blank');
    }
  };

  const handleWhatsApp = () => {
    const message = encodeURIComponent(t('contactGuestWhatsAppMessage', { reqClientName, orgNameInvoice }));
    window.open(`https://wa.me/${phone.replace(/[^0-9]/g, '')}?text=${message}`, '_blank');
  };

  const handleSMS = () => {
    const message = encodeURIComponent(t('contactGuestSMSMessage', { reqClientName, orgNameInvoice }));
    window.open(`sms:${phone}?body=${message}`, '_self');
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-2xl shadow-xl max-w-md w-full">
        {/* Header */}
        <div className="px-6 py-4 border-b border-slate-200">
          <div className="flex items-center justify-between">
            <div>
              <h2 className="text-xl font-semibold text-slate-900">
                {t('contactGuestModal')}
              </h2>
              <p className="text-sm text-slate-500">{reqClientName}</p>
            </div>
            <button
              onClick={onClose}
              className="p-2 text-slate-400 hover:text-slate-600 hover:bg-slate-100 rounded-lg transition-colors duration-200"
            >
              <X size={20} />
            </button>
          </div>
        </div>

        {/* Content */}
        <div className="p-6">
          <div className="space-y-4">
            {/* Phone Call */}
            <button
              onClick={handlePhoneCall}
              className="w-full flex items-center space-x-4 rtl:space-x-reverse p-4 bg-green-50 border border-green-200 rounded-xl hover:bg-green-100 transition-colors duration-200"
            >
              <div className="p-3 bg-green-100 rounded-xl">
                <Phone size={20} className="text-green-600" />
              </div>
              <div className="flex-1 text-end">
                <div className="font-semibold text-green-900">
                  {t('contactPhoneCall')}
                </div>
                <div dir='ltr' className="text-sm text-green-700">{phone}</div>
              </div>
              <ExternalLink size={16} className="text-green-600" />
            </button>

            {/* WhatsApp */}
            <button
              onClick={handleWhatsApp}
              className="w-full flex items-center space-x-4 rtl:space-x-reverse p-4 bg-green-50 border border-green-200 rounded-xl hover:bg-green-100 transition-colors duration-200"
            >
              <div className="p-3 bg-green-100 rounded-xl">
                <MessageSquare size={20} className="text-green-600" />
              </div>
              <div className="flex-1 text-end">
                <div className="font-semibold text-green-900">
                  {t('contactWhatsApp')}
                </div>
                <div dir='ltr' className="text-sm text-green-700">{phone}</div>
              </div>
              <ExternalLink size={16} className="text-green-600" />
            </button>

            {/* SMS */}
            <button
              onClick={handleSMS}
              className="w-full flex items-center space-x-4 rtl:space-x-reverse p-4 bg-blue-50 border border-blue-200 rounded-xl hover:bg-blue-100 transition-colors duration-200"
            >
              <div className="p-3 bg-blue-100 rounded-xl">
                <MessageSquare size={20} className="text-blue-600" />
              </div>
              <div className="flex-1 text-end">
                <div className="font-semibold text-blue-900">
                  {t('contactSMSMessage')}
                </div>
                <div dir='ltr' className="text-sm text-blue-700">{phone}</div>
              </div>
              <ExternalLink size={16} className="text-blue-600" />
            </button>

            {/* Email */}
            {email && (
              <button
                onClick={handleEmail}
                className="w-full flex items-center space-x-4 rtl:space-x-reverse p-4 bg-purple-50 border border-purple-200 rounded-xl hover:bg-purple-100 transition-colors duration-200"
              >
                <div className="p-3 bg-purple-100 rounded-xl">
                  <Mail size={20} className="text-purple-600" />
                </div>
                <div className="flex-1 text-end">
                  <div className="font-semibold text-purple-900">
                    {t('contactEmail')}
                  </div>
                  <div className="text-sm text-purple-700 truncate">{email}</div>
                </div>
                <ExternalLink size={16} className="text-purple-600" />
              </button>
            )}
          </div>
        </div>

        {/* Footer */}
        <div className="px-6 py-4 border-t border-slate-200">
          <button
            onClick={onClose}
            className="w-full bg-slate-100 hover:bg-slate-200 text-slate-700 font-semibold py-3 px-4 rounded-xl transition-colors duration-200"
          >
            {t('close')}
          </button>
        </div>
      </div>
    </div>
  );
};